/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unstable-nested-components */
// @ts-nocheck
import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { Form, useFormApi, useFormState } from 'informed';
import { Modal } from 'antd';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { setHours, setMinutes } from 'date-fns';

import { DATE_FORMAT } from '@common/constants';
import { useNonSpammyFieldState } from '@common/hooks';
import { notEmptyValidator } from '@common/utils';

import {
  AcceptingDriveData,
  FacilityDriver,
  FacilityVehicle,
  MappedDrive,
  IBookingRouteApi,
} from '@common/interfaces';
import { IDropdownOption } from '@ui-modules/types';
import { Button } from '@ui-modules';
import { Dropdown } from '@ui-modules/informed';
import { DateField, TextArea } from '../../legacyInputs';
import { checkConflictingDrivesOnAcceptance, checkDriveIsRideShared } from '../../utils';
import css from './styles.module.scss';

const moment = extendMoment(Moment as any);

const TIME_INTERVAL = 15;
const DATE_FORMAT_FULL = 'YYYY-MM-DD HH:mm:ss';

export const getFullDate = (date: Date, time: Date): Date =>
  moment(
    `${moment(date).format('YYYY-MM-DD')} ${moment(time).format('HH:mm')}`,
    'YYYY-MM-DD HH:mm',
  ).toDate();

interface IAcceptForm {
  acceptingDriveData: AcceptingDriveData[];
  drivers: FacilityDriver[];
  index: number;
  route: IBookingRouteApi;
  totalDrives: MappedDrive[];
  vehicles: FacilityVehicle[];
  rejectBooking: (value: string) => Promise<void>;
  setAcceptingDriveData: Dispatch<SetStateAction<AcceptingDriveData[]>>;
  setCurrentDate: Dispatch<SetStateAction<string | undefined>>;
}

interface IField {
  disabled?: boolean;
  driver?: number | null;
  initialValue?: string | null;
  vehicle?: number | null;
  leg?: number;
}

interface IFormData {
  driver: IDropdownOption;
  dropoff_date: Date;
  dropoff_time: Date;
  pickup_date: Date;
  pickup_time: Date;
  vehicle: IDropdownOption;
}

const AcceptForm: FC<IAcceptForm> = ({
  acceptingDriveData,
  drivers,
  index,
  totalDrives,
  vehicles,
  rejectBooking,
  setAcceptingDriveData,
  setCurrentDate,
}) => {
  const { t } = useTranslation();

  const legNumber = index + 1;

  const {
    accepted: acceptedForm,
    driver,
    dropoff_date,
    dropoff_time,
    pickup_date,
    pickup_time,
    vehicle,
    invalid = false,
  } = acceptingDriveData[index];

  const [accepted, setAccepted] = useState<boolean>(false);
  const [accepting, setAccepting] = useState<boolean>(false);
  const [rejecting, setRejecting] = useState<boolean>(false);

  const [isRideSharedConfirm, setRideSharedConfirm] = useState<boolean>(false);

  const driversOptions = drivers.map(
    ({ driver_identifier, last_name, name }: FacilityDriver): IDropdownOption => ({
      label: `${name} ${last_name}`,
      value: driver_identifier?.toString(),
    }),
  );

  const vehiclesOptions = vehicles.map(
    ({ label, key }: FacilityVehicle): IDropdownOption => ({ label, value: key.toString() }),
  );

  const DriverField: FC<IField> = ({ disabled, driver, leg }) => {
    const formApi = useFormApi();
    const { value: vehicle } = useNonSpammyFieldState<IDropdownOption>('vehicle');

    const [options, setOptions] = useState(driversOptions);

    useEffect(() => {
      const selectedVehicle = vehicles.find((v) => v.vehicle_identifier === vehicle?.value);

      if (selectedVehicle?.shared && selectedVehicle?.preferred_driver) {
        const preferred_driver = selectedVehicle?.preferred_driver;

        const preferredDriverOption = driversOptions.find((i) => i.value === preferred_driver);

        if (preferredDriverOption) {
          setOptions([preferredDriverOption]);
          formApi.setValue('driver', preferredDriverOption);
        } else {
          formApi.setValue('driver', driversOptions[0]);
        }
      } else {
        const sharedDrivers = drivers.filter((d: FacilityDriver) => d.shared);

        const excludeShared = driversOptions.filter(
          (i: IDropdownOption) => !sharedDrivers.find((d) => d.driver_identifier === i.value),
        );

        setOptions(excludeShared);

        const currentValue = formApi.getValue('driver') as IDropdownOption;

        if (currentValue && !excludeShared.some((d) => d.value === currentValue.value)) {
          formApi.setValue('driver', '');
        }
      }
    }, [vehicle]);

    return (
      <div className={css.field} data-testid={`accepting-drive-driver-leg-${leg}`}>
        <Dropdown
          defaultValue={driversOptions.find((i) => i.value === driver)}
          isDisabled={disabled}
          label={t('mobility.selectDriver')}
          name="driver"
          options={options}
          validate={notEmptyValidator}
        />
      </div>
    );
  };

  const DropOffDateField: FC<IField> = ({ disabled, initialValue }) => {
    const { value: pickup_date_value } = useNonSpammyFieldState<Date>('pickup_date');

    if (moment(pickup_date_value, DATE_FORMAT.API).isAfter(moment(initialValue, DATE_FORMAT.API))) {
      initialValue = moment(pickup_date_value).format(DATE_FORMAT.API);
    }

    return (
      <div className={css.field}>
        <DateField
          className={css.input}
          disabled={disabled}
          initialValue={initialValue ? moment(initialValue).toDate() : undefined}
          label={t('bookingDetails.dropoffDate')}
          minDate={pickup_date_value}
          name="dropoff_date"
          showMonthDropdown
          showYearDropdown
          validate={notEmptyValidator}
        />
      </div>
    );
  };

  const DropOffTimeField: FC<IField> = ({ disabled, initialValue, leg }) => {
    const formApi = useFormApi();
    const { touched } = useFormState();
    const { value: dropoff_time_value } = useNonSpammyFieldState('dropoff_time');
    const { value: pickup_time_value } = useNonSpammyFieldState('pickup_time');
    const { value: dropoff_date } = useNonSpammyFieldState<Date>('dropoff_date');
    const { value: pickup_date } = useNonSpammyFieldState<Date>('pickup_date');

    if (moment(pickup_time_value, 'HH:mm').isAfter(moment(initialValue, 'HH:mm'))) {
      initialValue = moment(pickup_time_value).add(TIME_INTERVAL, 'minutes').format('HH:mm');
    }

    const minEndTime = moment(pickup_time_value).add(TIME_INTERVAL, 'minutes');
    const isSameDate = moment(dropoff_date).isSame(pickup_date, 'day');

    useEffect(() => {
      if (
        'pickup_time' in touched &&
        pickup_time_value &&
        moment(pickup_time_value, 'HH:mm').isSameOrAfter(moment(dropoff_time_value, 'HH:mm'))
      ) {
        formApi.setValue(
          'dropoff_time',
          moment(pickup_time_value).add(TIME_INTERVAL, 'minutes').toDate(),
        );
      }
    }, [pickup_time_value]);

    return (
      <div className={css.field} data-testid={`accepting-drive-dropoff-time-leg-${leg}`}>
        <DateField
          className={css.input}
          dateFormat="HH:mm"
          defaultValue={initialValue ? moment(initialValue, 'HH:mm:ss').toDate() : undefined}
          disabled={disabled}
          label={t('bookingDetails.estimatedDropoffTime')}
          maxTime={isSameDate ? setHours(setMinutes(new Date(), 45), 23) : undefined}
          minTime={
            isSameDate
              ? setHours(setMinutes(new Date(), minEndTime.minutes()), minEndTime.hour())
              : undefined
          }
          name="dropoff_time"
          placeholder={t('bookingDetails.chooseTime')}
          showTimeSelect
          showTimeSelectOnly
          timeCaption={null}
          timeFormat="HH:mm"
          timeIntervals={TIME_INTERVAL}
          validate={notEmptyValidator}
        />
      </div>
    );
  };

  const PickupDateField: FC<IField> = ({ disabled, initialValue }) => {
    const { value: dropoff_date_value } = useNonSpammyFieldState<Date>('dropoff_date');

    const formApi = useFormApi();
    let minDate = moment(dropoff_date, DATE_FORMAT.API).toDate();

    if (index) {
      const prevData = acceptingDriveData[index - 1].dropoff_date;

      if (moment(prevData, DATE_FORMAT.API).isAfter(moment(dropoff_date, DATE_FORMAT.API))) {
        minDate = moment(prevData, DATE_FORMAT.API).toDate();
        initialValue = prevData;
      }
    }

    return (
      <div className={css.field}>
        <DateField
          className={css.input}
          disabled={disabled}
          dropdownMode="select"
          initialValue={moment(initialValue).toDate()}
          label={t('bookingDetails.pickupDate')}
          minDate={minDate}
          name="pickup_date"
          showMonthDropdown
          showYearDropdown
          validate={notEmptyValidator}
          onChange={(value: Date) => {
            if (moment(value).isAfter(dropoff_date_value)) {
              formApi.setValue('dropoff_date', value);
            }
          }}
        />
      </div>
    );
  };

  const PickupTimeField: FC<IField> = ({ disabled, initialValue }) => {
    const { value: pickup_date_value } = useNonSpammyFieldState('pickup_date');

    let minTime = moment(dropoff_time, 'HH:mm');

    if (index) {
      const prevDropoffTime = acceptingDriveData[index - 1].dropoff_time;
      minTime = moment(prevDropoffTime, 'HH:mm');

      if (moment(prevDropoffTime, 'HH:mm').isAfter(moment(pickup_time, 'HH:mm'))) {
        initialValue = prevDropoffTime;
      }
    }

    const currentDate = pickup_date_value
      ? moment(
          `${moment(pickup_date_value).format('DD-MM-YYYY')}-${initialValue}`,
          'DD-MM-YYYY-HH:mm:ss',
        )
      : null;

    const minDate = moment(`${dropoff_date}-${dropoff_time}`, 'YYYY-MM-DD-HH:mm');
    const isSameDate = moment(minDate).isSame(currentDate, 'day');

    return (
      <div className={css.field}>
        <DateField
          className={css.input}
          dateFormat="HH:mm"
          disabled={disabled}
          initialValue={moment(initialValue, 'HH:mm:ss').toDate()}
          label={t('bookingDetails.pickupTime')}
          minTime={
            index && isSameDate
              ? setHours(setMinutes(new Date(), minTime.minutes()), minTime.hour())
              : undefined
          }
          maxTime={index && isSameDate ? setHours(setMinutes(new Date(), 45), 23) : undefined}
          name="pickup_time"
          showTimeSelect
          showTimeSelectOnly
          timeCaption={null}
          timeFormat="HH:mm"
          timeIntervals={TIME_INTERVAL}
          validate={notEmptyValidator}
        />
      </div>
    );
  };

  const VehicleField: FC<IField> = ({ disabled, vehicle, leg }) => (
    <div className={css.field} data-testid={`accepting-drive-vehicle-leg-${leg}`}>
      <Dropdown
        defaultValue={vehiclesOptions.find((i) => i.value === vehicle)}
        isDisabled={disabled}
        label={t('mobility.selectVehicle')}
        name="vehicle"
        options={vehiclesOptions}
        validate={notEmptyValidator}
      />
    </div>
  );

  const onConfirmAccepting = async () => {
    setAcceptingDriveData((prevDrive: AcceptingDriveData[]) => {
      const currentDrive = prevDrive[index];
      const newDriveData = [...prevDrive];

      newDriveData[index] = {
        ...currentDrive,
        accepted: true,
      };

      return newDriveData;
    });

    setAccepted(true);
  };

  const onBackHandler = async () => {
    setAccepting(false);
    setAcceptingDriveData((prevDrive: AcceptingDriveData[]) => {
      const currentDrive = prevDrive[index];
      const newDriveData = [...prevDrive];

      newDriveData[index] = {
        ...currentDrive,
        is_hide: true,
      };

      return newDriveData;
    });
  };

  return (
    <div className={css.section}>
      <div className={css.title}>
        {t('bookingDetails.leg')} {legNumber}: {t('bookingDetails.processTrip')}
      </div>

      <div className={css.form}>
        <Form
          className={acceptedForm ? css['accepted-form'] : css['accept-form']}
          onSubmit={({
            values: { driver, dropoff_date, dropoff_time, pickup_date, pickup_time, vehicle },
          }: IFormData) => {
            const driveConflict = checkConflictingDrivesOnAcceptance({
              driver,
              drives: totalDrives,
              dropoff_date,
              dropoff_time,
              pickup_date,
              pickup_time,
              vehicle,
            })?.conflict;

            if (driveConflict) {
              return toast.error(
                `${t('bookingDetails.selected')} ${driveConflict} ${t(
                  'bookingDetails.messageConflictingMulti',
                )}`,
              );
            }

            setAccepting(true);
            setCurrentDate(moment(pickup_date).format(DATE_FORMAT.API));
            setAcceptingDriveData((prevDrive: AcceptingDriveData[]) => {
              const currentDriver = drivers.find(
                ({ driver_identifier }) => driver_identifier === driver.value,
              );
              const currentDrive = prevDrive[index];
              const newDriveData = [...prevDrive];

              newDriveData[index] = {
                ...currentDrive,
                driver: driver.value,
                driver_agency: currentDriver ? currentDriver.driver_agency : '',
                driver_email: currentDriver ? currentDriver.email : '',
                driver_first_name: currentDriver ? currentDriver.name : '',
                driver_id: currentDriver ? currentDriver.driver_identifier : null,
                driver_last_name: currentDriver ? currentDriver.last_name : '',
                driver_phone_number: currentDriver ? currentDriver?.phone_number : '',
                dropoff_date: moment(dropoff_date).format(DATE_FORMAT.API),
                dropoff_time: moment(dropoff_time).format('HH:mm'),
                is_hide: false,
                pickup_date: moment(pickup_date).format(DATE_FORMAT.API),
                pickup_time: moment(pickup_time).format('HH:mm'),
                vehicle: vehicle.value,
                vehicle_id: vehicle.value,
                start_date: moment(
                  `${moment(pickup_date).format(DATE_FORMAT.API)} ${moment(pickup_time).format(
                    'HH:mm',
                  )}`,
                  DATE_FORMAT_FULL,
                ).toDate(),
                end_date: moment(
                  `${moment(dropoff_date).format(DATE_FORMAT.API)} ${moment(dropoff_time).format(
                    'HH:mm',
                  )}`,
                  DATE_FORMAT_FULL,
                ).toDate(),
              };

              return newDriveData;
            });
          }}
        >
          <div className={css.panel}>
            <div className={css.fields}>
              <VehicleField disabled={accepting || rejecting} vehicle={vehicle} leg={legNumber} />
              <DriverField disabled={accepting || rejecting} driver={driver} leg={legNumber} />
              <PickupDateField disabled={accepting || rejecting} initialValue={pickup_date} />
              <PickupTimeField disabled={accepting || rejecting} initialValue={pickup_time} />
              <DropOffDateField disabled={accepting || rejecting} initialValue={dropoff_date} />
              <DropOffTimeField
                disabled={accepting || rejecting}
                initialValue={dropoff_time}
                leg={legNumber}
              />
            </div>
          </div>

          {accepting && !accepted ? (
            <div className={`${css.buttons} ${css.control}`}>
              <Button
                className={css.button}
                text={t('bookingDetails.btnConfirmAccepting')}
                variant="submit"
                onClick={() => {
                  const { driver, dropoff_date, dropoff_time, pickup_date, pickup_time, vehicle } =
                    acceptingDriveData[index];

                  const isRideShared = checkDriveIsRideShared({
                    driver,
                    drives: totalDrives,
                    dropoff_date,
                    dropoff_time,
                    pickup_date,
                    pickup_time,
                    vehicle,
                  });

                  if (isRideShared) {
                    setRideSharedConfirm(true);
                  } else {
                    onConfirmAccepting();
                  }
                }}
              />
              <Button
                className={css.button}
                text={t('common.btnBack')}
                variant="transparent"
                onClick={onBackHandler}
              />
            </div>
          ) : null}

          {!accepting && !rejecting && !accepted ? (
            <div className={`${css.buttons} ${css.control}`}>
              <Button
                text={t('bookingDetails.btnShowPreview')}
                disabled={invalid}
                variant="submit"
                type="submit"
                className={css.button}
              />
              <Button
                className={css.button}
                text={t('bookingDetails.btnReject')}
                variant="warning"
                onClick={() => setRejecting(true)}
              />
            </div>
          ) : null}
        </Form>

        {rejecting && !accepted ? (
          <Form
            className={css['reject-form']}
            onSubmit={(formState) => rejectBooking(formState.values.reason as string)}
          >
            <TextArea className={css.reason} name="reason" />
            <div className={css.buttons}>
              <Button
                className={css.button}
                text={t('bookingDetails.btnRejectNow')}
                type="submit"
                variant="danger"
              />
              <Button
                className={css.button}
                text={t('common.btnBack')}
                variant="transparent"
                onClick={() => setRejecting(false)}
              />
            </div>
          </Form>
        ) : null}
      </div>

      <Modal
        className="modal-planner-confirm"
        cancelText={t('common.no')}
        okText={t('common.yes')}
        open={isRideSharedConfirm}
        title={t('planner.createDrive')}
        onOk={() => {
          onConfirmAccepting();
          setRideSharedConfirm(false);
        }}
        onCancel={() => {
          onBackHandler();
          setRideSharedConfirm(false);
        }}
      >
        <div className={css.warning}>
          <p>{t('planner.multiWarn1')}.</p>
          <p>
            {t('common.click')} <b>{t('common.yes')}</b> {t('planner.multiWarn2')}{' '}
            {t('common.click')} <b>{t('common.no')}</b> {t('planner.multiWarn3')}.
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default AcceptForm;
